export default "<th data-bind=\"i18n, visible: visible\">First created</th>\n<th data-bind=\"i18n, visible: visible\">Last modified</th>\n";